import React from 'react';
import { motion } from 'framer-motion';
import { HammerIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-wood bg-cream" data-id="element-99" data-mp="4mi3fau9loeh">
      <p className="flex items-center justify-center gap-1.5 bg-charcoal px-3 py-1.5 font-display text-xs font-bold uppercase tracking-widest text-cta" data-id="element-100" data-mp="4jvvha3gp6vq">
        <HammerIcon size={12} aria-hidden="true" data-id="element-101" data-mp="xbflpdyh7l78" />
        Método de aprendizaje paso a paso
      </p>

      <div className="mx-auto max-w-2xl px-3 pb-5 pt-3 text-center sm:px-5" data-id="element-102" data-mp="s9zz3hgnh6mq">
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-anton text-[1.85rem] uppercase leading-[1.05] text-charcoal sm:text-5xl" data-id="element-103" data-mp="ncq4lneem4s1">
          El sistema completo para aprender{' '}
          <span className="text-wood underline decoration-cta decoration-4 underline-offset-4" data-id="element-104" data-mp="3j9kbrdwi3lh6">
            carpintería en melamina
          </span>{' '}
          desde cero
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mx-auto mt-2 max-w-xl text-sm leading-snug text-charcoal/85 sm:text-base" data-id="element-105" data-mp="399b9bibx13tc">
          Aprendé a diseñar y fabricar tus propios muebles, comprendé cómo
          medir, cortar y ensamblar melamina, y preparate para comenzar a
          ofrecer trabajos por encargo —{' '}
          <strong className="font-semibold text-charcoal" data-id="element-106" data-mp="2viy4houbm588">
            sin perderte entre cientos de videos, planos y tutoriales.
          </strong>
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.25,
        ease: EASE,
        delay: 0.1
      }} className="mt-2.5 inline-block rounded-md bg-wood px-3 py-1.5 font-display text-xs font-black uppercase leading-tight tracking-wide text-white" data-id="element-107" data-mp="2hjymh01bcol1">
          {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.14
      }} className="mt-2.5 block overflow-hidden rounded-xl border-4 border-wood bg-white" data-id="element-108" data-mp="ia5jsznr2lv8">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-109" data-mp="15zzwnh82kafh" />
        </motion.a>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.18
      }} className="mt-3" data-id="element-110" data-mp="x37a87fl3x8g">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-111" data-mp="3htq0vzu3syq5">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-medium text-charcoal/85" data-id="element-112" data-mp="21awemc9yyxi0">
            <span className="flex items-center gap-1" data-id="element-113" data-mp="268y6nmpdi75m">
              <ZapIcon size={12} className="text-wood" data-id="element-114" data-mp="26868q58azxc6" />
              Acceso Digital Inmediato
            </span>
            <span className="text-charcoal/40" data-id="element-115" data-mp="2g02kgj3bblyv">•</span>
            <span className="flex items-center gap-1" data-id="element-116" data-mp="2fzarlg13o2ca">
              <ShieldCheckIcon size={12} className="text-wood" data-id="element-117" data-mp="2kydt4qhvfqfi" />
              Garantía de 7 Días
            </span>
          </p>
        </motion.div>
      </div>
    </header>;
}